import { useState, useEffect, CSSProperties } from 'react';
import { IProduct } from 'mod/product/interface';
import { IListItemProduct, IListProduct } from 'mod/product-list/interface';
import { IProductContext, ProductContext } from './useProductContext';
import cn from 'classnames';
import Tracker from '@base/lib/Tracker';
import { getProductTrackData } from 'mod/feature/utils';

export type IProductRootProps =
    Omit<IProductContext, 'product' | 'products' | 'onChangeProduct' | 'num' | 'optionType'>
    & {
    item: IListItemProduct;
    className?: string;
    style?: CSSProperties;
    onClick?: (product: IListProduct) => void;
    canLinkJump?: boolean;
};

export const ProductRoot: Globals.FC<IProductRootProps> = props => {
    const {
        item,
        className,
        style,
        onClick,
        children,
        track,
        canLinkJump = true,
        ...rest
    } = props;

    const { products, num, optionType } = item;

    const [product, setProduct] = useState<IProduct>(products[0] as IProduct);

    const onChangeProduct = (newProduct: IListProduct) => {
        if (newProduct.variantId !== product.variantId) {
            setProduct(newProduct);
        }
    };

    useEffect(() => {
        setProduct(products[0] as IProduct);
    }, [item]);

    return !product ? null : (
        <ProductContext.Provider value={{
            product,
            onChangeProduct,
            products,
            num,
            optionType,
            canLinkJump,
            ...rest
        }}>
            <Tracker data={getProductTrackData(product, track)}>
                <div
                    className={cn(className, 'js-product')}
                    style={style}
                    onClick={() => onClick?.(product)}
                >
                    {children}
                </div>
            </Tracker>
        </ProductContext.Provider>
    )
};